import { CombinedGraphQLErrors, ErrorLike } from '@apollo/client';
import { GraphQLFormattedError } from 'graphql';

/**
 * Apollo Client 4 の結果から GraphQL エラーを取り出す（AC3 の `result.errors` に相当）。
 *
 * 通信エラーは `createApolloClient`（graphql.module.ts）が reject に戻しているので、ここには GraphQL エラーしか来ない。
 */
export function gqlErrors(result: { error?: ErrorLike }): ReadonlyArray<GraphQLFormattedError> | undefined {
  return CombinedGraphQLErrors.is(result.error) ? result.error.errors : undefined;
}
